import { Link } from "react-router-dom";

const microPoints = [
  { icon: "ri-eye-off-line", text: "全程可选择匿名" },
  { icon: "ri-route-line", text: "提交不做 IP 留痕" },
  { icon: "ri-time-line", text: "72 小时内首次回应" },
];

export default function HeroSection() {
  return (
    <section className="relative flex min-h-[780px] w-full items-center overflow-hidden bg-foreground-950 pb-20 pt-32 md:min-h-[880px] md:pb-24">
      <img
        src="https://readdy.ai/api/search-image?query=dark%20cinematic%20abstract%20night%20alley%20with%20drifting%20fog%20and%20one%20narrow%20shaft%20of%20warm%20amber%20light%20cutting%20across%2C%20deep%20charcoal%20shadows%2C%20crimson%20accent%20glow%20on%20wet%20ground%2C%20fine%20film%20grain%2C%20moody%20investigative%20editorial%20photography%2C%20wide%20empty%20negative%20space%2C%20no%20people&width=1920&height=1200&seq=anxian-hero-main&orientation=landscape"
        alt="深夜巷道中的一束暖光，象征匿名爆料线索征集通道"
        title="独家爆料线索征集 - 匿名投稿与私信通道"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/85 to-foreground-950/40"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-transparent to-foreground-950/70"></div>

      <div className="relative mx-auto w-full max-w-[1320px] px-5 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/5 px-4 py-1.5 text-xs tracking-[0.18em] text-accent-300 backdrop-blur-sm">
            <span className="amb-live-dot h-1.5 w-1.5 rounded-full bg-accent-400"></span>
            独家爆料线索征集 · 通道全天开放
          </span>

          <h1 className="mt-7">
            <span className="block font-label text-sm font-medium tracking-[0.28em] text-background-200/80">
              暗线 · 独家爆料线索征集中心
            </span>
            <span className="mt-4 block font-heading text-4xl font-bold leading-[1.15] text-background-50 md:text-6xl">
              把你知道的，
              <br />
              交到该去的地方
            </span>
          </h1>

          <p className="mt-7 max-w-2xl text-sm leading-7 text-background-200/85 md:text-base md:leading-8">
            面向知情者与内部人士征集原始素材与文件。你提供线索，我们负责核实与呈现，并按你的要求隐藏身份。
            不必一次交出全部，先从一条消息开始也可以。
          </p>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/submit"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-shield-keyhole-line text-base"></i>
              立即提交线索
            </Link>
            <Link
              to="/guide"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              先看投稿指南
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>

          <ul className="mt-12 flex flex-wrap gap-x-8 gap-y-4">
            {microPoints.map((point) => (
              <li key={point.text} className="flex items-center gap-2.5 text-sm text-background-200/80">
                <span className="flex h-6 w-6 items-center justify-center rounded-full border border-accent-400/40 text-accent-300">
                  <i className={`${point.icon} text-xs`}></i>
                </span>
                {point.text}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}